<template>
  <div class="new-credentials-card-single-or-joint">
    <div class="bank-title">
      <span>
        בנק דיסקונט
      </span>
      <div class="remove-container" v-on:click="() => remove('X')">
        <img :src="require('@/assets/icons/close-fat.svg')">
      </div>
    </div>
    <div class="instructions-container">
כמה בעלים רשומים יש לחשבון?
    </div>

    <div class="buttons-container">
      <riseup-button :variant="'discount-secondary'"
                     :title="'חשבון עם בעלים יחיד'"
                     :subtitle="'החשבון רשום על שם אדם אחד בלבד'"
                     :action="() => setAccountType(accountTypes.SINGLE)" />

      <riseup-button :variant="'discount-secondary'"
                     :title="'משותף עם מס\' בעלים'"
                     :subtitle="'לדוג\': רשום על שם שני בני זוג'"
                     :action="() => setAccountType(accountTypes.JOINED)" />
    </div>


    <bank-footer :source="source" />
  </div>
</template>

<script>

import { mapActions } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '../../../../Segment';
import BankFooter from './../BankFooter.vue';

export default {
  name: 'NewCredentialsCardSingleOrJoint',
  props: [
    'source',
    'setAccountType',
    'accountTypes',
  ],
  components: {
    RiseupButton: BaseUI.RiseupButton,
    BankFooter,
  },
  created() {
    Segment.trackUserGot('DiscountApiFlow_Shown');
  },
  methods: {
    ...mapActions('credentials', ['deleteCredentials']),
    async remove(buttonName) {
      Segment.trackUserInteraction('RemoveAccountClicked', {
        name: this.source.sourceName,
        button: buttonName,
      });
      await this.deleteCredentials({ credentialsId: this.source.credentialsId });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../scss/mixins';

  .new-credentials-card-single-or-joint {
    position: relative;
    width: 100%;
    border-radius: 3px;
    box-shadow: 2px 2px 8px 0 $riseup_gray_1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .bank-title {
      @include card-title;
      margin-bottom: 11px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0 30px;
      padding-top: 24px;

      .remove-container {
        position: absolute;
        top: 9px;
        left: 10px;
        cursor: pointer;

        img {
          height: 23px;
        }
      }
    }

    .remove-container-text {
      text-align: center;
      color: $riseup_light_blue;
      text-decoration: underline;
      cursor: pointer;
      margin: 25px auto;
      font-family: SimplerProBold;
    }

    .instructions-container {
      padding: 0 30px 22px;
      font-size: 20px;
      font-weight: normal;
      line-height: 1.2em;
      font-family: SimplerPro;
    }

    .buttons-container {
      margin: 0 30px 15px 30px;

      .riseup-button {
        width: 100%;
        margin-bottom: 15px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/base-components/credentials/credentials-card/discount/DiscountNewCredentialsCardSingleOrJoint.vue